import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Parse from 'parse'

import '@babel/polyfill'
import 'mutationobserver-shim'

import './plugins/bootstrap-vue'
import './assets/scss/style.scss';
import './assets/css/style.css';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    Parse.initialize("myAppId", "myJavascriptKey");
    Parse.serverURL = "https://parse-server-ekasbon.herokuapp.com/parse";
  }
}).$mount('#app')
